var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagerStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#c3c4d0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-chart-no-axes-combined-icon lucide-chart-no-axes-combined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16v5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14v7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10v11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14v7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerStatistics);
export default __webpack_public_path__ + "static/media/manager-statistics.364358ee210f941f00b8bf6521d49a23.svg";
export { ForwardRef as ReactComponent };